import { Component, OnInit, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { ClaimCriteria } from './_models/claim-criteria';
import { BehaviorSubject } from 'rxjs';
import { SortEvent, SortableDirective } from 'src/app/_directives/sortable.directive';
import { HeaderData } from 'src/app/_models/header-data';
import { ClaimService } from 'src/app/_services/claim.service';
import { Router } from '@angular/router';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { StatusCode, Modules } from 'src/app/_common/_enum/module.enum';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-claim-list',
  templateUrl: './claim-list.component.html',
  styleUrls: ['./claim-list.component.scss']
})
export class ClaimListComponent implements OnInit, OnDestroy {

  private criteria: ClaimCriteria;
  private claims = [];
  //private hasClaims: boolean = true;
  private hasAccess: boolean = true;
  private _total$ = new BehaviorSubject<number>(0);
  private loading: boolean = false;
  private filterObj: Object[];

  resultsNotFound = RESULTS_NOT_FOUND;

  private selectedLossDate;
  private selectedStatus;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  
  //private killServicesOnDestroy = [];

  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;

  constructor(private router: Router, private claimService: ClaimService, private commonService: CommonService) { }

  ngOnInit() {
    this.filterObj = [
      {filterIndex: 0, displayName : 'All', value: 'All', group: 'ClaimStatus'},
      {filterIndex: 1, displayName : 'Open Claims', value: 'Open', group: 'ClaimStatus'},
      {filterIndex: 2, displayName : 'Closed Claims', value: 'Close', group: 'ClaimStatus'},
      {filterIndex: 3, displayName : 'All', value: 'All', group: 'DateOfLoss'},
      {filterIndex: 4, displayName : 'Past 30 Days', value: 'Past30Days', group: 'DateOfLoss'},
      {filterIndex: 5, displayName : 'Past 60 Days', value: 'Past60Days', group: 'DateOfLoss'},
      {filterIndex: 6, displayName : 'Past 90 Days', value: 'Past90Days', group: 'DateOfLoss'},
      {filterIndex: 7, displayName : 'Past 120 Days', value: 'Past120Days', group: 'DateOfLoss'},
    ];
    this.criteria = new ClaimCriteria();

    this.selectedLossDate = this.filterObj.find((obj:any) => {return obj.group == 'DateOfLoss' && obj.displayName == 'All'});
    this.selectedStatus = this.filterObj.find((obj:any) => {return obj.group == 'ClaimStatus' && obj.displayName == 'All'});

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.resetCriteria();

    this.fetchClaims();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Claims";
    this.claimService.header = this.headerData;  
  }

  fetchClaims(){
    this.loading = true;
    this.hasAccess = this.commonService.checkPermission(Modules.ClaimList);
    if(this.hasAccess){
      let claimsSubscription = this.claimService.fetchClaims(this.criteria).subscribe((claims:any) => {
        this.loading = false;
        this._total$.next(claims.totalClaims);
        this.claims = claims.claims;
        //this.hasClaims = this.claims && this.claims.length > 0;

        console.log(this._total$);
      },error=>{
        this.loading = false;
        //this.hasClaims = false;
        this.claims = null;

        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });

      this.claimService.runningServices.push(claimsSubscription);
    }else{
      this.loading = false;
    }
  }

  get total$() { return this._total$.asObservable(); }
  
  /* ***Filter Code*** */
  onFilter(item, type){
    if(type == this.selectedLossDate.group){
      this.selectedLossDate = item;
    }else if(type == this.selectedStatus.group){
      this.selectedStatus = item;
    }
    this.criteria.filterBy = [{
      "FilterColumnName": this.selectedLossDate.group,
      "FilterValue": this.selectedLossDate.value
    },
    {
      "FilterColumnName": this.selectedStatus.group,
      "FilterValue": this.selectedStatus.value
    }]
    /*this.criteria.sortBy = "dateReported";
    this.criteria.sortOrder = "desc";*/
    this.criteria.pageNo = 1;
    this.fetchClaims();
  }
  /* Filter Code */
  
  /* ***Sorting Code*** */
  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction !== '') {
      this.criteria.sortOrder = direction;
      this.criteria.sortBy = column;
      this.criteria.pageNo = 1;
      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      this.fetchClaims();
    }
  }
  /* Sorting Code */

  openClaimDetails(claim){
    this.claimService.storeClaimData(claim);
    this.router.navigateByUrl("claims/"+claim.claimNumber);
  }
  resetCriteria(){
    this.criteria.pageNo = 1;
    this.criteria.pageSize = 50;
    this.criteria.sortBy = "dateReported";
    this.criteria.sortOrder = "desc";
    this.criteria.filterBy = [{
      "FilterColumnName": this.selectedLossDate.group,
      "FilterValue": this.selectedLossDate.displayName
    },
    {
      "FilterColumnName": this.selectedStatus.group,
      "FilterValue": this.selectedStatus.displayName
    }];
  }

  getClaimStatusClass(status){
    return (status.toLowerCase() === "re-open" || status.toLowerCase() === "reopen" || status.toLowerCase() === "open")?"open":((status.toLowerCase() === "close" || status.toLowerCase() === "closed" || status.toLowerCase() === "cancelled"))?"closed":"";
  }

  ngOnDestroy() {
    this.claimService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
